import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
	GetAni({ commit }, ani_group_uuid) {
		return new Promise(resolve => {
			axios({
				url: "/ani_group/" + ani_group_uuid,
				method: "GET"
			}).then(res => {
				resolve(res.data.payload);
			});
		});
	},
	GetAniList({ commit }, list) {
		return new Promise(resolve => {
			axios({
				url: "/ani_group/list",
				params: {
					page: list.page || 0,
					per_page: list.per_page || 10,
					ani_group_name: list.ani_group_name ? `${list.ani_group_name}*` : '',
					order_by: list.order_by || 'created_on',
					order_dir: list.order_dir || 'desc'
				},
				method: "GET"
			}).then(res => {
				resolve(res.data.payload);
			});
		});
	},
	GetAniNumbers({ commit }, list) {
		return new Promise(resolve => {
			axios({
				url: "/ani_group/" + list.id + '/list',
				params: {
					page: list.page || 0,
					per_page: list.per_page || 10,
					order_by: list.order_by || '',
					order_dir: list.order_dir || 'desc',
				},
				method: "GET"
			}).then(res => {
				resolve(res.data.payload);
			});
		});
	},
	AddAniGroup({ commit }, ani_group) {
		return new Promise((resolve, reject) => {
			axios({
				url: "/ani_group",
				data: ani_group,
				method: "POST"
			}).then(res => {
				resolve(res.data.payload);
			})
				.catch(err => {
					reject(err);
				});
		});
	},
	EditAniGroup({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
				url: "/ani_group/" + data.id,
				data: data.aniGroup,
				method: "PATCH"
			}).then(res => {
				resolve(res.data.payload);
			})
				.catch(err => {
					reject(err);
				});
		});
	},
	DeleteAniGroup({ commit }, id) {
		return new Promise(resolve => {
			axios({
				url: "/ani_group/" + id,
				method: "DELETE"
			}).then(res => {
				resolve(res.data);
			});
		});
	},
};

// mutations
const mutations = {
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
};
